import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import FilterGroup from "./FilterGroup";
import Filter from "./Filter";
import SvgIcons from "../restaurant/SvgIcons";
import Select from 'react-select';


class FilterMenu extends React.Component {
  static propTypes = {
    activeFilters: PropTypes.object,
    clearAllFilters: PropTypes.func,
    filters: PropTypes.object,
    handleClick: PropTypes.func,
    handleClickFilter: PropTypes.func,
    handleSelectFilter: PropTypes.func,
    itemNumber: PropTypes.number,
    template: PropTypes.string,
    toggle: PropTypes.string
  };

  // check if icon should be active or not
  checkIfActive(id, group) {
    return this.props.activeFilters[group].indexOf(id) !== -1;
  }

  // render icon filters
  listFilters(group) {
    let filter_list = this.props.filters;
    let free = '';
    let name_variable = 'name';
    if(group === 'diets'){
      free = '-free';
      name_variable = 'filter_name';
    }
    if (filter_list) {
      return filter_list[group].map((filter) => {
        return (
          <Filter key={group + '-' + filter.id} slug={filter.slug}
                  className={'filter' + group} filterType={group} name={filter[name_variable]} id={filter.id}
                  onClick={this.props.handleClickFilter} active={this.checkIfActive(filter.id, group)}>
            <SvgIcons icon={filter.slug + free}/>
          </Filter>
        );
      });
    }
  }

  // render select filters
  listSelect(option) {
    if (this.props.filters) {
      return this.props.filters[option].map((item) => {
        return (
          {
            value: item.id,
            label: item.name,
            key: 'region-' + item.id,
            filter: option
          }
        );
      });
    }
  }


  setPlaceholders(option) {
    return (<FormattedMessage id={option + "_default_option"}>
      {(message) => <span>{message}</span>}
    </FormattedMessage>);

  }


  filtersRender(template) {
    if (template === "") {
      return null;
    }

    if (template === 'wine') { // CHECKING IF IT IS A WINE ITEM
      return (
        <div>
          <FilterGroup
              filterTemplate="wine"
              listFilters={[
                <Select key="0" options={this.listSelect('wine_type')}
                        clearable={false}
                        id="wine_type"
                        name="type"
                        value={Number(this.props.activeFilters.wine_type[0])}
                        onChange={(e) => this.props.handleSelectFilter(e.value, 'wine_type')}
                        searchable={false}
                        placeholder={this.setPlaceholders("type")}/>,
                <Select key="1" options={this.listSelect('wine_regions')}
                        clearable={false}
                        id="wine_regions"
                        name="region"
                        value={Number(this.props.activeFilters.wine_regions[0])}
                        onChange={(e) => this.props.handleSelectFilter(e.value, 'wine_regions')}
                        searchable={false}
                        placeholder={this.setPlaceholders("region")}/>]}
            filterTitle="region-type"/>
          <FilterGroup filterTemplate="wine" listFilters={[this.listFilters("sweetness"), this.listFilters("body")]}
                       filterTitle="characteristics"/>
        </div>
      );
    }

    else { // CHECKING IF ITS NOT A WINE ITEM
      return (
        <div>
          <FilterGroup listFilters={[this.listFilters("ingredients")]} filterTitle="ingredients"/>

          {this.props.filters.diets.length > 0 ?
            <FilterGroup listFilters={[this.listFilters("diets")]} filterTitle="diets"/>
            : null}
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        <header className={"filters-header " + this.props.toggle}>
          <div className="results">
            {/*TOTAL OF FILTERED RESULTS*/}
            <FormattedMessage id="filters">
              {(message) => <h4>{message}</h4>}
            </FormattedMessage>
            <FormattedMessage id="filter-results" values={{results: this.props.itemNumber || '0'}}/>
          </div>
          {/*CLEAR BUTTON*/}
          <FormattedMessage id="filter-clear-button">
            {(message) => <button className="clear-btn"
                                  data-value="clear" onClick={this.props.clearAllFilters.bind(this)}>{message}</button>}
          </FormattedMessage>

          {/*APPLY BUTTON*/}
          <FormattedMessage id="filter-apply-button">
            {(message) => <button className="apply-btn"
                                  data-value="apply" onClick={this.props.handleClick}>{message}</button>}
          </FormattedMessage>
        </header>
        <div className={"filter-menu " + this.props.toggle} id="filterMenu">
          {this.filtersRender(this.props.template)}
        </div>
      </div>
    );
  }
}

export default FilterMenu;



/** WEBPACK FOOTER **
 ** ./src/components/nav/FilterMenu.js
 **/